import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Box from '@material-ui/core/Box';

import { textFieldStyle, common, dropDownStyle } from '../../../theme/AllocateBaseTheme';
import Table from '../../../containers/common/tables/tableContainer';
import globals from '../../../globals/communityGlobals';
import { patientHistoricVisitsTable } from '../../../settings/constants/endpoints';
import _ from '../../../utils/lodash';
import ToolTip from './ToolTip';
import PatientRescheduledInformationDialogOpenerContainer from '../../../containers/Patients/Patient/PatientRescheduledInformationDialogOpenerContainer';

const locale = globals.getAreas(['patients', 'treatments']);

const standartColumnWidth = 230;
const midColumnWidth = 175;
const activitiesWidth = 500;
const minsWidth = 70;

const visitTypes = {
  UNALLOCATED: 'Unallocated',
  ALLOCATED: 'Allocated',
  CANCELLED: 'Cancelled',
  COMPLETED: 'Completed',
};

const visitTypeObjectNames = {
  unallocated: 'unallocatedVisits',
  allocated: 'allocatedVisits',
  cancelled: 'canceledVisits',
  completed: 'completedVisits',
};

const commonColumnFields = [
  { Header: locale.getMsg('activities'), accessor: 'activities', width: activitiesWidth },
  { Header: locale.getMsg('mins'), accessor: 'mins', width: minsWidth },
];

const columnFields = {
  [visitTypeObjectNames[visitTypes.UNALLOCATED.toLowerCase()]]: [
    ...commonColumnFields,
    {
      Header: locale.getMsg('date'),
      id: 'date',
      accessor: row => (row.date ? moment(row.date).format(globals.dateFormats.short) : '-'),
    },
    {
      Header: locale.getMsg('treatmentSchedule'),
      id: 'timeSlots',
      accessor: row => <ToolTip timeSlots={row.timeSlots} />,
      width: standartColumnWidth,
    },
    {
      Header: locale.getMsg('dateOfUnallocation'),
      id: 'dateOfUnallocation',
      accessor: row =>
        row.dateOfUnallocation ? moment(row.dateOfUnallocation).format(globals.dateFormats.shortWithTime) : '',
      width: standartColumnWidth,
    },
    {
      Header: locale.getMsg('clinicianThatUnallocated'),
      accessor: 'clinicianThatUnallocated',
      width: standartColumnWidth,
    },
    {
      Header: locale.getMsg('isRescheduled'),
      id: 'isRescheduled',
      accessor: row =>
        row.isRescheduled ? (
          <PatientRescheduledInformationDialogOpenerContainer
            treatmentInstanceId={row.treatmentInstanceId}
            id={`${row.treatmentInstanceId.toString() + row.treatmentId.toString() + row.date}`}
          />
        ) : (
          ''
        ),
      width: standartColumnWidth,
    },
  ],
  [visitTypeObjectNames[visitTypes.ALLOCATED.toLowerCase()]]: [
    ...commonColumnFields,
    { Header: locale.getMsg('clinicians'), accessor: 'clinicians' },
    {
      Header: locale.getMsg('dateOfVisit'),
      id: 'dateOfVisit',
      accessor: row => (row.dateOfVisit ? moment(row.dateOfVisit).format(globals.dateFormats.short) : ''),
      width: standartColumnWidth,
    },
    {
      Header: locale.getMsg('startTime'),
      id: 'startDate',
      accessor: row => (row.startDate ? moment(row.startDate).format(globals.timeFormats.hours24) : ''),
      width: standartColumnWidth,
    },
    {
      Header: locale.getMsg('endTime'),
      id: 'endDate',
      accessor: row => (row.endDate ? moment(row.endDate).format(globals.timeFormats.hours24) : ''),
      width: standartColumnWidth,
    },
  ],
  [visitTypeObjectNames[visitTypes.COMPLETED.toLowerCase()]]: [
    ...commonColumnFields,
    { Header: locale.getMsg('clinicians'), accessor: 'clinicians' },
    {
      Header: locale.getMsg('dateOfVisit'),
      id: 'dateOfVisit',
      accessor: row => (row.dateOfVisit ? moment(row.dateOfVisit).format(globals.dateFormats.short) : ''),
      width: standartColumnWidth,
    },
    {
      Header: locale.getMsg('startTime'),
      id: 'startDate',
      accessor: row => (row.startDate ? moment(row.startDate).format(globals.timeFormats.hours24) : ''),
      width: standartColumnWidth,
    },
    {
      Header: locale.getMsg('endTime'),
      id: 'endDate',
      accessor: row => (row.endDate ? moment(row.endDate).format(globals.timeFormats.hours24) : ''),
      width: standartColumnWidth,
    },
  ],
  [visitTypeObjectNames[visitTypes.CANCELLED.toLowerCase()]]: [
    ...commonColumnFields,
    {
      Header: locale.getMsg('dateOfCancellation'),
      id: 'dateOfCancellation',
      accessor: row =>
        row.dateOfCancellation ? moment(row.dateOfCancellation).format(globals.dateFormats.shortWithTime) : '',
      width: midColumnWidth,
    },
    { Header: locale.getMsg('clinicianThatCancelled'), accessor: 'clinicianThatCancelled', width: midColumnWidth },
    { Header: locale.getMsg('reason'), accessor: 'reason' },
    { Header: locale.getMsg('riskAssesment'), accessor: 'riskAssesment', width: midColumnWidth },
    { Header: locale.getMsg('status'), accessor: 'status', width: 75 },
    { Header: locale.getMsg('orgUnit'), accessor: 'orgUnit' },
  ],
};

class PatientHistoricVisits extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedOption: visitTypes.COMPLETED,
      days: 30,
      callbackModel: {
        funcName: '',
        funcParams: null,
      },
    };
  }

  handleChangeMenu = (event, index, value) => {
    this.setState({
      selectedOption: value,
    });
  };

  handleDataMenu = (event, index, value) => {
    const numberOfPreviousDays = value > 0 ? value : null;

    this.setState({
      days: numberOfPreviousDays,
      callbackModel: { funcName: 'updateParamsAndGetData', funcParams: { numberOfPreviousDays } },
    });
  };

  render() {
    const { selectedOption, days } = this.state;
    const selectedDays = !days ? -1 : days;

    const objectName = visitTypeObjectNames[selectedOption.toLowerCase()];
    return (
      <div className="tab-box">
        <Box display="flex">
          <Box p={1}>
            <SelectField
              id="patient-select-visits-type"
              floatingLabelStyle={common.floatingLabelStyle}
              floatingLabelShrinkStyle={textFieldStyle.floatingLabelShrinkStyle}
              style={textFieldStyle.displayBlock}
              labelStyle={dropDownStyle.labelStyleNonFormsy}
              inputStyle={textFieldStyle.inputStyle}
              underlineStyle={textFieldStyle.underlineStyle}
              iconStyle={dropDownStyle.iconStyle}
              floatingLabelText={locale.getMsg('selectVisitType')}
              onChange={this.handleChangeMenu}
              value={selectedOption}
            >
              {_.entries(visitTypes).map(([, value]) => (
                <MenuItem
                  key={`patientHistoricVisitsMenuItem${value}`}
                  value={value}
                  primaryText={locale.getMsg(`patientHistoricVisitsOption${value}`)}
                />
              ))}
            </SelectField>
          </Box>
          <Box p={1}>
            <SelectField
              id="patient-select-days"
              floatingLabelStyle={common.floatingLabelStyle}
              floatingLabelShrinkStyle={textFieldStyle.floatingLabelShrinkStyle}
              style={textFieldStyle.displayBlock}
              labelStyle={dropDownStyle.labelStyleNonFormsy}
              inputStyle={textFieldStyle.inputStyle}
              underlineStyle={textFieldStyle.underlineStyle}
              iconStyle={dropDownStyle.iconStyle}
              onChange={this.handleDataMenu}
              floatingLabelText={locale.getMsg('showVisitsFor')}
              value={selectedDays}
            >
              <MenuItem value={30} primaryText={locale.getMsg('patientHistoricVisitsOptionThirtyDays')} />
              <MenuItem value={90} primaryText={locale.getMsg('patientHistoricVisitsOptionNinetyDays')} />
              <MenuItem value={-1} primaryText={locale.getMsg('patientHistoricVisitsOptionAllDays')} />
            </SelectField>
          </Box>
        </Box>

        <Table
          className="inpage-table"
          reloadCallback={this.state.callbackModel}
          afterReloadCallback={() => this.setState({ callbackModel: { funcName: '', funcParams: null } })}
          key={`patientHistoricVisitsTable${selectedOption}`}
          initialSearchParams={{
            patientPasKey: this.props.patientId,
            pageNumber: 1,
            pageSize: 30,
            numberOfPreviousDays: days,
            isCompleted: selectedOption === visitTypes.ALLOCATED ? false : undefined,
          }}
          reduxIdentifier="patientHistoricVisits"
          endpoint={patientHistoricVisitsTable[selectedOption.toLowerCase()]}
          responseObjectName={objectName}
          columns={columnFields[objectName]}
        />
      </div>
    );
  }
}

PatientHistoricVisits.propTypes = {
  patientId: PropTypes.string.isRequired,
};

export default PatientHistoricVisits;
